export default [
	{
		path: '/',
		name: 'locations',
		component: () => import('@/views/locations/index.vue'),
		meta: {
			resource: 'Home',
			pageTitle: 'Administrador'
		},
	}
]
